import { Dispatch } from "redux";
import { loadAndTrack } from "redux-request-loading";

import {
    loadHrRepresentativesSuccess,
    loadLineManagersSuccess,
    loadRecruitmentManagersSuccess
} from "@teamprevent/common/questionnaires/components/referralForm/actions";

import { customerApi } from "../crud/customer";
import { CUSTOMER_ROLES } from "../auth";

export const loadLineManagers = ({ customerId }: { customerId: string }) => {
    return async (dispatch: Dispatch) => {
        const lineManagers = await loadAndTrack(
            dispatch, "LOAD_LINE_MANAGERS", customerApi.customerUsersByRole(customerId, { role: CUSTOMER_ROLES.MANAGER.name }));

        dispatch(loadLineManagersSuccess(lineManagers.map(u =>
            ({ id: u.id, name: `${u.firstName} ${u.surname}`, email: u.emailAddress, telephone: u.mobileNumber })
        )));
    };
};

export const loadHrUsers = ({ customerId }: { customerId: string }) => {
    return async (dispatch: Dispatch) => {
        const hrUsers = await loadAndTrack(dispatch, "LOAD_HR_USERS", customerApi.customerUsersByRole(customerId, { role: CUSTOMER_ROLES.HR.name }));
        dispatch(loadHrRepresentativesSuccess(hrUsers.map(u =>
            ({ id: u.id, name: `${u.firstName} ${u.surname}`, email: u.emailAddress }))));
    };
};

export const loadRecruitmentManagers = ({ customerId }: { customerId: string }) => {
    return async (dispatch: Dispatch) => {
        const recruitmentManagers = await loadAndTrack(
            dispatch,
            "LOAD_RECRUITMENT_MANAGERS",
            customerApi.customerUsersByRole(customerId,{ role: CUSTOMER_ROLES.RECRUITMENT_MANAGER.name }));

        dispatch(loadRecruitmentManagersSuccess(recruitmentManagers.map(u =>
            ({ id: u.id, name: `${u.firstName} ${u.surname}`, email: u.emailAddress, telephone: u.mobileNumber }))));
    };
};
